<script setup lang="ts">
provideGameReset()
provideGameFullscreen()
</script>

<template>
  <slot/>
  <AboutModal/>
</template>
